import { z } from 'zod';

export const CoreAddressScalarFieldEnumSchema = z.enum(['id','attn','address','address2','city','state','zip','rowTimestamp','countryId']);

export default CoreAddressScalarFieldEnumSchema;
